export default {"src":"/_next/static/media/ic_person.04110b71.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};